import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { MODULO_FERROVIA } from '~/constants/modules';
import { t, can } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/operacaoLimpezaDvec/actions';

import Form from './form';

function OperacaoLimpezaDvec() {
  const redux = useSelector((state) => state.operacaoLimpezaDvec);

  const options = useMemo(
    () => [
      { label: 'V', value: t('s.menu.cadastro.veiculo.veiculo') },
      { label: 'C', value: t('s.cadastro.veiculo.comboio') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.operacao.limpezatag.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.operacao.limpezatag.placaveiculo'),
        filter: { type: 'text' },
      },

      {
        id: 'tipoveiculostr',
        label: t('s.operacao.limpezatag.tipoveiculo'),
        formatted: (value) =>
          options.find((o) => o.label === value).value || '',
        filter: { type: 'select', options },
      },

      {
        id: 'nomeempresaveiculo',
        label: t('s.operacao.limpezatag.nomeempresaveiculo'),
      },

      {
        id: 'possuidvecveiculostr',
        label: t('s.operacao.limpezatag.possuidvecveiculostr'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  useEffect(() => {
    if (can(MODULO_FERROVIA)) {
      options.push({
        label: 'L',
        value: t('s.cadastro.veiculo.locomotiva'),
      });
    }
  }, []);

  const fieldlist = [
    'idveiculo',
    'placaveiculo',
    'tipoveiculostr',
    'nomeempresaveiculo',
  ];

  const substituirHeader = {
    idveiculo: t('s.operacao.limpezatag.idveiculo'),
    placaveiculo: t('s.operacao.limpezatag.placaveiculo'),
    tipoveiculostr: t('s.operacao.limpezatag.tipoveiculo'),
    nomeempresaveiculo: t('s.operacao.limpezatag.nomeempresaveiculo'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idveiculo"
      detach="idveiculo"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'historicosdvecs',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Limpeza Dvec',
          substituirValores: {
            tipoveiculostr: {
              V: t('s.menu.cadastro.veiculo.veiculo'),
              C: t('s.cadastro.veiculo.comboio'),
              L: t('s.cadastro.veiculo.locomotiva'),
            },
          },
        })
      }
    />
  );
}

export default OperacaoLimpezaDvec;
